export default __webpack_public_path__ + "static/soehne-web-halbfett-102b3152e9db37ee3fab63ea13f29d20.woff";